import Decimal from "decimal.js";
import { Token } from "../store/global/TokenEnum";
import { TokenMetadata } from "../store/global/getTokenMetadata";
import formatLocaleNumber, { fallbackDisplayDecimals } from "../utils/amountUtils";

Decimal.set({ precision: 28 }); // Set global Decimal Precision
export class Amount {
  public static ZERO: Amount = new Amount("0");
  public value: Decimal;
  public formatted: string;

  constructor(value: string) {
    this.value = new Decimal(value);
    this.formatted = this.value.toString();
  }

  mul(otherAmount: Amount): Amount {
    const newVal = this.value.mul(otherAmount.value);
    return new Amount(newVal.toString());
  }

  add(otherAmount: Amount): Amount {
    const newVal = this.value.add(otherAmount.value);
    return new Amount(newVal.toString());
  }

  div(otherAmount: Amount): Amount {
    const newVal = this.value.div(otherAmount.value);
    return new Amount(newVal.toString());
  }

  sub(otherAmount: Amount): Amount {
    return new Amount(this.value.sub(otherAmount.value).toString());
  }

  toString(): string {
    return this.value.toString();
  }

  toDisplay(symbol: Token, tokenMetaData: TokenMetadata | undefined): string {
    const locale = navigator.language;
    // We ROUND_HALF_CEIL as this is what's classed as classic rounding
    const displayDecimals = fallbackDisplayDecimals(symbol, tokenMetaData);
    const roundedValue = this.value.toDP(displayDecimals, Decimal.ROUND_HALF_CEIL);
    const stringValue = roundedValue.toFixed(displayDecimals);
    const valueToDisplay = formatLocaleNumber({
      number: stringValue,
      locale: locale,
      displayDecimals,
    });
    return valueToDisplay;
  }

  format(fractionalDigits: number): string {
    return Intl.NumberFormat(navigator.language, {
      maximumFractionDigits: fractionalDigits,
      minimumFractionDigits: fractionalDigits,
    }).format(this.value.toDP(fractionalDigits).toNumber());
  }
}
